import * as React from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import { TreeView } from '@mui/x-tree-view/TreeView';
import StyledTreeItem, { environmentsColorCodes } from './StyledTreeItem';
import useAppSwitcherTree from './useAppSwitcherTree';
import { Tenant } from '../hooks/useAppSwitcherDataTypes';

interface AppSwitcherTreeProps {
  tenants: Tenant[];
}

const AppSwitcherTree = ({ tenants }: AppSwitcherTreeProps) => {
  const { tree, allNodeIds } = useAppSwitcherTree(tenants);

  const renderTree = (nodes: Tenant[]) =>
    nodes.map((node) => (
      <StyledTreeItem
        key={node.id}
        nodeId={node.id ? node.id : ''}
        labelText={node.name || 'Unnamed Tenant'}
        environment={node.environment as keyof typeof environmentsColorCodes}
        targetUrl={node.entities ? node.entities[0].targetUrl : ''}
        tenandId={node.id ? node.id : ''}
        labelIcon={
          node.appType === 'BILLING'
            ? ReceiptOutlinedIcon
            : AttachMoneyOutlinedIcon
        }
      >
        {node.children && node.children.length > 0
          ? renderTree(node.children)
          : null}
      </StyledTreeItem>
    ));

  return (
    <TreeView
      aria-label="tenant-tree"
      defaultExpanded={allNodeIds}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      sx={{ height: 264, flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
    >
      {renderTree(tree)}
    </TreeView>
  );
};

export default AppSwitcherTree;
